import './skills.css'
const About = () => {
  return (
    <div id="skills" className="a">
        <h1 className="a-title">Skills</h1>
    <div className='container'>

      <div className="a-left" >
        <div className="a-card bg"></div>
        <div className="a-card">
          <img
            src="https://www.kindpng.com/picc/m/243-2430191_transparent-information-technology-clipart-graphic-design-institute-in.png"
            alt=""
            className="a-img"
          />
        </div>
      </div>

      <div className="a-right">
    <div className='skill'>

        <div className="flip-card">
          <div className="flip-card-inner skills-card">
            <div className="flip-card-front">
              <img className='skills-card-img' src="icons/html.png" alt="Avatar" />
            </div>
            <div className="flip-card-back">
              <p className="skills-card-name">HTMl</p>
            </div>
          </div>
        </div>

        <div className="flip-card">
          <div className="flip-card-inner skills-card">
            <div className="flip-card-front">
              <img className='skills-card-img' src="icons/css.png" alt="Avatar" />
            </div>
            <div className="flip-card-back">
              <p className="skills-card-name">CSS</p>
            </div>
          </div>
        </div>

        <div className="flip-card">
          <div className="flip-card-inner skills-card">
            <div className="flip-card-front">
              <img className='skills-card-img' src="icons/javascript.png" alt="Avatar" />
            </div>
            <div className="flip-card-back">
              <p className="skills-card-name">Js</p>
            </div>
          </div>
        </div>

        <div className="flip-card">
          <div className="flip-card-inner skills-card">
            <div className="flip-card-front">
              <img className='skills-card-img' src="icons/react.png" alt="Avatar" />
            </div>
            <div className="flip-card-back">
              <p className="skills-card-name">react</p>
            </div>
          </div>
        </div>

        <div className="flip-card">
          <div className="flip-card-inner skills-card">
            <div className="flip-card-front">
              <img className='skills-card-img' src="icons/redux.png" alt="Avatar" />
            </div>
            <div className="flip-card-back">
              <p className="skills-card-name">Redux</p>
            </div>
          </div>
        </div>

        <div className="flip-card">
          <div className="flip-card-inner skills-card">
            <div className="flip-card-front">
              <img className='skills-card-img' src="icons/sass.png" alt="Avatar" />
            </div>
            <div className="flip-card-back">
              <p className="skills-card-name">Sass</p>
            </div>
          </div>
        </div>

        <div className="flip-card">
          <div className="flip-card-inner skills-card">
            <div className="flip-card-front">
              <img className='skills-card-img' src="icons/bootstrap.png" alt="Avatar" />
            </div>
            <div className="flip-card-back">
              <p className="skills-card-name">Bootstrap</p>
            </div>
          </div>
        </div>

        <div className="flip-card">
          <div className="flip-card-inner skills-card">
            <div className="flip-card-front">
              <img className='skills-card-img' src="icons/materialui.png" alt="Avatar" />
            </div>
            <div className="flip-card-back">
              <p className="skills-card-name">materialui</p>
            </div>
          </div>
        </div>

        <div className="flip-card">
          <div className="flip-card-inner skills-card">
            <div className="flip-card-front">
              <img className='skills-card-img' src="icons/styled.png" alt="Avatar" />
            </div>
            <div className="flip-card-back">
              <p className="skills-card-name">styled</p>
            </div>
          </div>
        </div>

        <div className="flip-card">
          <div className="flip-card-inner skills-card">
            <div className="flip-card-front">
              <img className='skills-card-img' src="icons/heroku.png" alt="Avatar" />
            </div>
            <div className="flip-card-back">
              <p className="skills-card-name">Heroku</p>
            </div>
          </div>
        </div>

        <div className="flip-card">
          <div className="flip-card-inner skills-card">
            <div className="flip-card-front">
              <img className='skills-card-img' src="icons/json.png" alt="Avatar" />
            </div>
            <div className="flip-card-back">
              <p className="skills-card-name">json server</p>
            </div>
          </div>
        </div>

        <div className="flip-card">
          <div className="flip-card-inner skills-card">
            <div className="flip-card-front">
              <img className='skills-card-img' src="icons/motion.png" alt="Avatar" />
            </div>
            <div className="flip-card-back">
              <p className="skills-card-name">Framer motion</p>
            </div>
          </div>
        </div>

        </div>
      </div>

    </div>
    </div>
  )
}

export default About
